import { useEffect, useState } from "react";
import "./BusinessData.scss";
import { Form, Input, Select } from "antd";
import { getCompanyInformation } from "../../services/CompanyInformation";
import { AxiosResponse } from "axios";
import { getCompanyRegistration } from "../../services/RegistrationService";

const BusinessData = (props: any) => {
  const [form] = Form.useForm();
  const [oneCompanyInformation, setOneCompanyInformation] = useState<any>();

  const insuranceCompany = [
    {
      label: "Da",
      value: true,
    },
    {
      label: "Ne",
      value: false,
    },
  ];

  useEffect(() => {
    // getCompanyInformation(
    //   props?.oneParticipant?.registration?.registrationCompanyName
    // ).then((res: AxiosResponse) => {
    //   setOneCompanyInformation(res.data.result);
    // });
    getCompanyRegistration(
      props?.oneParticipant?.registration?.registrationCompanyId
    ).then((res: AxiosResponse) => {
      setOneCompanyInformation(res.data.result);
    });
  }, [props]);

  return (
    <div className="business-data-participants">
      {oneCompanyInformation && (
        <Form
          form={form}
          name="new-legal-entity-form"
          layout="vertical"
          autoComplete="off"
        >
          <div className="inner-box">
            <Form.Item name="companyName" label="Naziv pravnog lica:">
              <Input
                className="input-label"
                placeholder="Unesite naziv pravnog lica"
                defaultValue={oneCompanyInformation?.companyName}
                disabled
              />
            </Form.Item>
            <Form.Item name="isInsuranceCompany" label="Osiguravajuće društvo:">
              <Select
                placeholder="Da li je osiguravajuće društvo?"
                defaultValue={
                  oneCompanyInformation.isInsuranceCompany ? "Da" : "Ne"
                }
                options={insuranceCompany}
                disabled
              />
            </Form.Item>

            <Form.Item name="companyCountry" label="Drzava:">
              <Input
                className="input-label"
                placeholder="Unesite adresu"
                defaultValue={oneCompanyInformation?.companyCountry}
                disabled
              />
            </Form.Item>
            <Form.Item name="companyCity" label="Grad:">
              <Input
                className="input-label"
                placeholder="Unesite adresu"
                defaultValue={oneCompanyInformation?.companyCity}
                disabled
              />
            </Form.Item>
            <Form.Item name="companyStreet" label="Ulica:">
              <Input
                className="input-label"
                placeholder="Unesite adresu"
                defaultValue={oneCompanyInformation?.companyStreet}
                disabled
              />
            </Form.Item>
            <Form.Item name="companyStreetNumber" label="Broj ulice:">
              <Input
                className="input-label"
                placeholder="Unesite adresu"
                defaultValue={oneCompanyInformation?.companyStreetNumber}
                disabled
              />
            </Form.Item>
            <Form.Item
              rules={[
                {
                  validateTrigger: "submit",
                  type: "email",
                  message: "Unesite ispravan format e-maila!",
                },
              ]}
              name="companyEmail"
              label="E-mail:"
            >
              <Input
                className="input-label"
                placeholder="Unesite e-mail"
                defaultValue={oneCompanyInformation?.companyEmail}
                disabled
              />
            </Form.Item>
            <Form.Item name="companyId" label="Matični broj:">
              <Input
                type="number"
                className="input-label"
                placeholder="Unesite matični broj"
                defaultValue={oneCompanyInformation?.companyId}
                disabled
              />
            </Form.Item>
            <Form.Item name="vatNumber" label="PIB:">
              <Input
                type="number"
                className="input-label"
                placeholder="Unesite PIB"
                defaultValue={oneCompanyInformation?.vatNumber}
                disabled
              />
            </Form.Item>

            <Form.Item name="companyPhone" label="Kontakt telefon:">
              <Input
                type="number"
                className="input-label"
                placeholder="Unesite kontakt telefon"
                defaultValue={oneCompanyInformation?.companyPhone}
                disabled
              />
            </Form.Item>
          </div>
        </Form>
      )}
    </div>
  );
};

export default BusinessData;
